import { EntityService } from './EntityService';
import config from '../config.json';
import axios from 'axios';
import * as PBIModels from 'powerbi-models';
import { models } from 'powerbi-client';
import { AuthorizationService } from './AuthorizationService';
import { v4 as uuidv4 } from 'uuid';

export class ReportService extends EntityService {
    constructor(){
        super('reports');
    }

    getEmbedData = async (client, report) => {
        return (await axios.get(config.BASE_URL + 'clients/' + client.id + '/reports/' + report.id + '/embeddata')).data;
    }

    getEmbedConfig = async (client, report) => {
        const embedData = await this.getEmbedData(client, report);
        const embedConfig = {
            type: 'report',
            id: report.powerbi_report_id,
            embedUrl: embedData.embedUrl,
            accessToken: embedData.accessToken,
            tokenType: models.TokenType.Embed,
            settings: {
                panes: {
                    pageNavigation: {
                        visible: report.config.hasOwnProperty("pbi_page_navigation") ? report.config.pbi_page_navigation : true,
                        position: PBIModels.PageNavigationPosition.Left
                    }
                },
                layoutType: models.LayoutType.Custom,
                customLayout: {
                    pageSize: {
                        type: models.PageSizeType.Custom,
                        width: '100%',
                        height: '100%'
                    }
                }
            }
        };
        return embedConfig;
    }

    isReportFavorite = (report) => {
        return ((new AuthorizationService()).loggedInUser.favorites || []).indexOf(report.id) >= 0;
    }

    toggleReportAsFavorite = async (report, flag) => {
        const authorizationService = new AuthorizationService();
        const loggedInUser = Object.assign({}, authorizationService.loggedInUser);
        
        if(!loggedInUser.favorites){
            loggedInUser.favorites = [];
        }

        if(flag){
            loggedInUser.favorites.push(report.id);
        }
        else {
            loggedInUser.favorites = loggedInUser.favorites.filter(f => f !== report.id);
        }
 
        console.log(loggedInUser.favorites);
        await authorizationService.updateFavorites(loggedInUser);
    }

    addReportFilterBookmark = async (report, name, state) => {
        const authorizationService = new AuthorizationService();
        const loggedInUser = Object.assign({}, authorizationService.loggedInUser);
        
        if(!loggedInUser.bookmarks){
            loggedInUser.bookmarks = {};
        }

        if(!loggedInUser.bookmarks[report.id]){
            loggedInUser.bookmarks[report.id] = [];
        }

        loggedInUser.bookmarks[report.id].push({id: uuidv4(), name, state});
        
        await authorizationService.updateBookmarks(loggedInUser);
    }

    removeReportFilterBookmark = async (report, id) => {
        const authorizationService = new AuthorizationService();
        const loggedInUser = Object.assign({}, authorizationService.loggedInUser);
        
        loggedInUser.bookmarks[report.id] = loggedInUser.bookmarks[report.id].filter(i => i.id !== id);
        
        await authorizationService.updateBookmarks(loggedInUser);
    }

    requestReportPrint = async (client, report, reportState) => {
        return (await axios.post(config.BASE_URL + 'clients/' + client.id + '/reports/' + report.id + '/requestprint', { reportState })).data;
    }

    checkReportPrintStatus = async (accessToken, reportId, groupId, exportId) => {
        try {
            const restUrl = `https://api.powerbi.com/v1.0/myorg/groups/${groupId}/reports/${reportId}/exports/${exportId}`;
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + accessToken
                }
            };
            const response = await axios.get(restUrl, config);
            return response.data;
        } catch (error) {
            console.log(error.response);
            throw error;
        }
    }

    getReportPDF = async (accessToken, restUrl) => {
        try {
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + accessToken
                },
                responseType: 'blob'
            };
            const response = await axios.get(restUrl, config);
            return response.data;
        } catch (error) {
            console.log(error.response);
            throw error;
        }
    }

    getAccessToken = async (client) => {
        const data = (await axios.get(config.BASE_URL + 'clients/' + client.id + '/reports/token', {})).data;
        return data;
    }

    listPBIworkspaces = async (client) => {
        try {
            const accessToken = await this.getAccessToken(client);
            const restUrl = `https://api.powerbi.com/v1.0/myorg/groups`;
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + accessToken
                }
            };
            const response = await axios.get(restUrl, config);
            return response.data;
        } catch (error) {
            console.log(error.response);
            throw error;
        }
    }

    listPBIReports = async (client, groupId) => {
        try {
            const accessToken = await this.getAccessToken(client);
            const restUrl = `https://api.powerbi.com/v1.0/myorg/groups/${groupId}/reports`;
            const config = {
                headers: {
                    "Accept": "application/json",
                    "Authorization": "Bearer " + accessToken
                }
            };
            const response = await axios.get(restUrl, config);
            return response.data;
        } catch (error) {
            console.log(error.response);
            throw error;
        }
    }

    getLastDatasetRefresh = async (client, report) => {
        try 
        { 
            console.log("getLastDatasetRefresh", client)
            const datasetId = report.powerbi_dataset_id;
            const groupId = report.powerbi_group_id;
            const apiURL = `https://api.powerbi.com/v1.0/myorg/groups/${groupId}/datasets/${datasetId}/refreshes?$top=1`;
          const config = { 
              headers: { 
                  'Content-Type': 'application/json',
                  "Authorization": "Bearer " + (await this.getAccessToken(client))
              }
          };
          
          const response = (await axios.get(apiURL, config)).data;
          return response && response.value ? response.value[0] : null;
        } catch (error) {
            console.log(error.response);
            throw error;   
        }
    }

    requestDatasetRefresh = async (client, report) => {
        try {
            const datasetId = report.powerbi_dataset_id;
            const groupId = report.powerbi_group_id;
            const apiURL = `https://api.powerbi.com/v1.0/myorg/groups/${groupId}/datasets/${datasetId}/refreshes`;
            const payload = {};
            const requestBody = JSON.stringify(payload);
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + (await this.getAccessToken(client))
                },
            };
    
            const response = await axios.post(apiURL, requestBody, config);
            return response.data;
        } catch (error) {
          throw error;
        }
      }
    

    checkAccess = async (client, report) => {
        return (await axios.get(config.BASE_URL + 'clients/' + client.id + '/reports/' + report.id + '/check-access')).data;
    }
}